export default __webpack_public_path__ + "static/media/Logo-Dark.93986ab5.svg";